import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProjectDetails.css";
// eslint-disable-next-line
import i18n from "../../i18n";
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import { useTranslation } from 'react-i18next';
  

import {Carousel} from 'react-bootstrap';

const ProjectDetails = ({heading , image1 ,image2 ,image3 , image4 ,Category, compatibility, date, href , Url, descriptionH , description }) => {
   const { t, i18n } = useTranslation();  
    
    return (
       
        <>
            <section class="breadcrumbs">
                <div dir='ltr' class="container">
                    <h2  >{heading}</h2>
                </div>
            </section>


            <section class="ourprojects-details">
                <div class="container">
                    <div class="row gy-4">
                        <div class="col-lg-8">
                            <div class="ourprojects-details-slider swiper-container">
                                <Carousel>
                                    <Carousel.Item interval="5000">
                                        <img src={image1} className="d-block w-100" />
                                    </Carousel.Item>
                                    <Carousel.Item interval="5000">
                                        <img src={image2} className="d-block w-100" />
                                    </Carousel.Item>
                                    <Carousel.Item interval="5000">
                                        <img src={image3} className="d-block w-100" />
                                    </Carousel.Item>
                                    <Carousel.Item interval="5000">
                                        <img src={image4} className="d-block w-100" />
                                    </Carousel.Item>
                                </Carousel>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="ourprojects-info">
                                <h3>{t('Project_information')}</h3>
                                <ul>
                                    <li><strong>{t('Category')}: </strong>{Category}</li>
                                    <li><strong>{t('Device_compatibility')}: </strong>{compatibility}</li>
                                    <li><strong>{t('Project_date')}: </strong>{date}</li>
                                    <li><strong>{t('Project_URL')}: </strong><a href={href}>{Url}</a></li>
                                </ul>
                            </div>
                            <div class="ourprojects-description">
                                <h2>{descriptionH}</h2>
                                <p>{description}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
</>
    )
}

export default ProjectDetails
